import "leaflet/dist/leaflet.css";
import { CircleMarker, MapContainer, Polyline, TileLayer, Tooltip } from "react-leaflet";
import { TYPE } from "@/lib/jobs";

const ok = (p) => p && p.lat != null && p.lng != null;
const ago = (iso) => Math.max(0, Math.round((Date.now() - new Date(iso)) / 60000));

export const JobMap = ({ hospitals = [], jobs = [], locations = [], height = 380, center = [52.85, -2.15], zoom = 8 }) => (
  <div className="relative isolate z-0 overflow-hidden rounded-2xl border" style={{ height }} data-testid="job-map">
    <MapContainer center={center} zoom={zoom} scrollWheelZoom={false} style={{ height: "100%", width: "100%" }}>
      <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      {hospitals.filter(ok).map((h) => (
        <CircleMarker key={h.id} center={[h.lat, h.lng]} radius={5} pathOptions={{ color: "#111", fillColor: "#fff", fillOpacity: 1, weight: 2 }}><Tooltip>{h.name}</Tooltip></CircleMarker>
      ))}
      {jobs.filter((j) => ok(j.pickup) && ok(j.dropoff)).map((j) => (
        <Polyline key={j.id} positions={[[j.pickup.lat, j.pickup.lng], [j.dropoff.lat, j.dropoff.lng]]} pathOptions={{ color: TYPE[j.job_type]?.color || "#DB0000", weight: 4, dashArray: j.status === "collected" ? null : "6 8" }}>
          <Tooltip sticky>{j.ref} · {TYPE[j.job_type]?.label} · {j.rider_name || "unassigned"}</Tooltip>
        </Polyline>
      ))}
      {locations.filter(ok).map((l) => (
        <CircleMarker key={l.user_id} center={[l.lat, l.lng]} radius={11} pathOptions={{ color: "#000", fillColor: "#FEDC19", fillOpacity: 1, weight: 3 }}>
          <Tooltip permanent direction="top" offset={[0, -10]}>{l.name} · {ago(l.at)}m ago</Tooltip>
        </CircleMarker>
      ))}
    </MapContainer>
  </div>
);
